import api from './api';

export const wishlistService = {
  toggle: (productId) => api.post(`/wishlist/${productId}/toggle`),
  getStatus: (productId) => api.get(`/wishlist/${productId}/status`),
  getAll: (params) => api.get('/wishlist', { params }),
};
